export * from "-!../node_modules/extract-text-webpack-plugin/dist/loader.js??ref--9-0!../node_modules/vue-style-loader/index.js!../node_modules/css-loader/index.js??ref--9-2!../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../node_modules/sass-loader/lib/loader.js??ref--9-3!../node_modules/vue-loader/lib/index.js??vue-loader-options!./App.vue?vue&type=style&index=0&id=2bffa07a&prod&lang=scss"


//////////////////
// WEBPACK FOOTER
// ./src/App.vue?vue&type=style&index=0&id=2bffa07a&prod&lang=scss
// module id = MIx9
// module chunks = 41